/*
 * @Author: WYX
 * @Date: 2019/12/26
 * @LastEditTime: 2021-05-19 10:45:41
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\directive\editPagePart\editPageEditor\editPageEditor.js
 * @Description: 编辑器指令模块
 */

angular.module('editPageEditorModule', []).directive('editPageEditor', [
    '$state',
    '$q',
    'messagePublishService',
    function ($state, $q, messagePublishService) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './editingCenter/directive/editPagePart/editPageEditor/editPageEditor.html',
            replace: true,
            link: function ($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description]初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {
                        support: {
                            // 获取输入内容
                            content: '',
                        },
                        type: $scope.parentStatus.type ? $scope.parentStatus.type : 'video',
                    };
                }

                /**
                 * [initData description]初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    if ($scope.parentStatus.articleid) {
                        messagePublishService.subscribe(
                            `${$scope.parentStatus.mediaName}ListInit`,
                            function () {
                                loadDirective();
                            },
                            $scope
                        );
                    } else {
                        loadDirective();
                    }
                }

                /**
                 * [loadDirective description]动态加载指令
                 * @return  {[type]}  [return description]
                 */
                function loadDirective() {
                    let defer = $q.defer();
                    if (!$state.params.issave || $state.params.issave === '0') {
                        // 用于融合编辑器的虚拟表单校验，虚拟表单检验不需要加载编辑器
                        LazyLoad.js(['./lib/ueditor2/ueditor.config.js?v=11.5', './lib/ueditor2/ueditor.all.js?v=11.8'], function () {
                            var ueditor =
                                '<ueditor class="newEditor" edit-flag="editFlag" draft-type="' +
                                $scope.status.type +
                                '" type="{{\'newmedia\'}}" versionid="parentData.lastVersionid" list="list" has-content="status.hasContent"></ueditor>';
                            ueditor = $scope.compile(ueditor)($scope);
                            $scope.element.find('ueditorLocation').append(ueditor);
                            var ue = UE.getEditor('ueditor');
                            $scope.status.support.content = $scope.list.CONTENT;
                            ue.ready(function () {
                                ue.addListener('keydown', function (type, event) {
                                    if (event.keyCode === 13) {
                                        $scope.status.support.content = ue.getContentTxt();
                                    }
                                });
                                defer.resolve();
                            });
                        });
                    } else {
                        defer.resolve();
                    }
                    return defer.promise;
                }
            },
        };
    },
]);
